import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { State } from '../../redux/store'
import { NewsInterface, ShowNewsContext, modalType } from './types'
import { useTranslation } from 'react-i18next'
import ToggleImages from './ToggleImages'
import { FaEdit } from 'react-icons/fa'
import { MdRemoveCircleOutline } from 'react-icons/md'

const DataNews = () => {
  const { news } = useSelector((state: State) => state.news)
  const { t } = useTranslation()

  const { 
    setSelectedNews,
    showEditNewsModal, setShowEditNewsModal,
    showDeleteNewsModal, setShowDeleteNewsModal,
    setSelectedModal
  } = useContext(ShowNewsContext)

  const toggleEditModal = (News: NewsInterface) => {
    setShowEditNewsModal(!showEditNewsModal)
    setSelectedNews(News)
    setSelectedModal(modalType.EditModal)
  }

  const toggleDeleteModal = (News: NewsInterface) => {
    setShowDeleteNewsModal(!showDeleteNewsModal)
    setSelectedNews(News)
    setSelectedModal(modalType.DeleteModal)
  }

  return (
    <div className='grid md:grid-cols-3 gap-2 mt-3'>
      {news.map((actuality: NewsInterface, index: number) => {
        return <section className='bg-white rounded p-2 flex flex-col justify-between' key={index}>
          <ToggleImages actuality={actuality}/>
          <section>
            <div className='flex justify-between'>
              <b>{t("Titre")}: </b>
              <p>{actuality.title}</p>
            </div>
            <div>{/* className={`flex justify-between`}  */}
              <b>{t("Content")}: </b>
              <p>{actuality.content}</p>
            </div>
          </section>
          <div className='flex justify-center'>
            <FaEdit className='text-second text-2xl' onClick={() => toggleEditModal(actuality)} />
            <MdRemoveCircleOutline className='text-red text-2xl' onClick={() => toggleDeleteModal(actuality)} />
          </div>
        </section>
      })}
    </div>
  )
}

export default DataNews